/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import React, { Component } from 'react'
import autoBind from 'react-autobind'

export default class Panel extends Component {
  constructor (props) {
    super(props)
    autoBind(this)

    this.state = {
      height: 0
    }
  }

  updateHeight () {
    if (this.props.subscribeHeight && this.panel.offsetHeight !== this.state.height) {
      this.setState({
        height: this.panel.offsetHeight
      })
      this.props.subscribeHeight(this.panel.offsetHeight)
    }
  }

  componentDidMount () {
    this.updateHeight()
    window.addEventListener('resize', this.updateHeight)
  }

  componentDidUpdate () {
    this.updateHeight()
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.updateHeight)
  }

  render () {
    return (
      <div
        ref={(panel) => this.panel = panel}
        className='Panel'
        style={Object.assign({}, {flex: '1 1 ' + this.props.width + '%'}, this.props.style)}
      >
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/generic/panels/Panel.js